class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.initQuantitySelectors(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.initQuantitySelectors(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  // 🔧 Updated function
  static renderProductGridContainer(html) {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    gridContainer.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    // set grid height to equal for all cards
    gridContainer.querySelectorAll(".product-card-wrapper").forEach(function (element) {
      let cardHeight = element.getBoundingClientRect().height;
      element.style.height = cardHeight + 'px';
    });

    setTimeout(() => {

      //sort by filter
      const sortItems = document.querySelectorAll('.custom-sort-item');
      const sortSelect = document.getElementById('SortBy');
      const form = document.getElementById('FacetSortForm');
      if (!sortItems.length || !sortSelect || !form) {
        return;
      }
      sortItems.forEach(item => {
        item.addEventListener('click', function () {
          const selectedValue = item.getAttribute('data-value');
          sortSelect.value = selectedValue;
          form.submit();
        });
      });

      /* ============================
        DESKTOP TOGGLES (In Stock, On Sale, etc.)
      ============================ */
      document.querySelectorAll('.facets__summary-toggle-inner').forEach(toggleInner => {
        const mainInput = toggleInner.querySelector('input[type="checkbox"]');
        if (!mainInput) return;
        
        document.querySelectorAll('.facets__disclosure-vertical').forEach(vertical => {
          const matchingInput = vertical.querySelector('.facets__item input[type="checkbox"][data-value="' + mainInput.value + '"]');
          if (matchingInput) {
            mainInput.checked = matchingInput.checked;
            mainInput.disabled = matchingInput.disabled;
          }
        });
        
        toggleInner.addEventListener('click', () => {
          const valueToMatch = mainInput.value;
          document.querySelectorAll('.facets__disclosure-vertical').forEach(vertical => {
            const matchingInput = vertical.querySelector('.facets__item input[type="checkbox"][data-value="' + valueToMatch + '"]');
            if (matchingInput && matchingInput !== mainInput) {
              if (matchingInput.checked !== mainInput.checked) {
                matchingInput.click();
              }
            }
          });
        });
      });

      /* ============================
        MOBILE TOGGLES (In Stock, On Sale, etc.)
      ============================ */
      document.querySelectorAll('.facets__summary-toggle-inner-mobile').forEach(toggleInner => {
        const mainInput = toggleInner.querySelector('input[type="checkbox"]');
        if (!mainInput) return;
        
        document.querySelectorAll('.mobile-facets__item').forEach(item => {
          const matchingInput = item.querySelector('.mobile-facets__label input[type="checkbox"][data-value="' + mainInput.value + '"]');
          if (matchingInput) {
            mainInput.checked = matchingInput.checked;
            mainInput.disabled = matchingInput.disabled;
          }
        });

        toggleInner.addEventListener('click', () => {
          const valueToMatch = mainInput.value;
          document.querySelectorAll('.mobile-facets__item').forEach(item => {
            const matchingInput = item.querySelector('.mobile-facets__label input[type="checkbox"][data-value="' + valueToMatch + '"]');
            if (matchingInput && matchingInput !== mainInput) {
              if (matchingInput.checked !== mainInput.checked) {
                matchingInput.click();
              }
            }
          });
        });
      });

      // bulk purchase dropdown js
      document.querySelectorAll('.bulk_purchase_card_wrapper .bulk-container').forEach(container => {
        const selected = container.querySelector('.bulk-purchase-selected');
        const options = container.querySelector('.bulk-purchase-dropdown-options');
        const card = container.closest('.product-card-wrapper');
        const input = card.querySelector('input[name="quantity"]');      

        if (!selected || !options || !input) return;
        selected.addEventListener('click', (e) => {
          e.stopPropagation();
          document.querySelectorAll('.bulk-purchase-dropdown-options.show').forEach(opt => {
            if (opt !== options) opt.classList.remove('show');
          });      
          options.classList.toggle('show');
        });

        options.querySelectorAll('li.bulk-purchase-dropdown-item').forEach(option => {
          option.addEventListener('click', () => {
            const value = option.getAttribute('data-value');
            const priceElement = option.querySelector('.bulk-purchase-dropdown-price');
            const priceSpan = priceElement?.querySelector('.pp');
            const priceData = priceSpan?.getAttribute('data-price');
            const priceValue = priceElement?.innerHTML;

            selected.querySelector('.bulk-purchase-dropdown-qty').textContent = value;
            selected.querySelector('.bulk-purchase-dropdown-price').innerHTML = priceValue;
            input.value = value;
            options.classList.remove('show');
            const priceTarget = container.closest('.card')?.querySelector('.price__container .price-item--regular');
            if (priceTarget && priceData) {
              priceTarget.textContent = priceData;
            }
          });
        });

        if (card) {
          card.addEventListener('mouseleave', () => {
            options.classList.remove('show');
          });
        }      
      });
      // bulk purchase dropdown js
      
      //collection size variant dropdown js
      const dropdowns = document.querySelectorAll(".custom-dropdown");
      dropdowns.forEach((dropdown) => {
        const selected = dropdown.querySelector(".dropdown-selected");
        const options = dropdown.querySelector(".dropdown-options");
        const items = dropdown.querySelectorAll(".dropdown-options li:not(.disabled)");
        const defaultItem = dropdown.querySelector(".dropdown-options li.selected");
        if (defaultItem) {
          selected.innerHTML = defaultItem.innerHTML;
        }
        selected.addEventListener("click", function (event) {
          event.stopPropagation();
          options.style.display = options.style.display === "block" ? "none" : "block";

        });
        items.forEach((item) => {
          item.addEventListener("click", function () {
            const inputEl = this.closest('.card__content').querySelector('.variant-id');
            const current_value = this.getAttribute('data-value');
            const productHandle = this.closest('.card-wrapper').getAttribute('data-product-handle');
            const tagContainer = this.closest('.card-wrapper').querySelector('.card_product_tag');
            const tagtopContainer = this.closest('.card-wrapper').querySelector('.price_top_tag-metadata');

            if (inputEl.value !== current_value) {
              inputEl.value = current_value;
            }
            selected.innerHTML = this.innerHTML;
            items.forEach((i) => i.classList.remove("selected"));
            this.classList.add("selected");
            options.style.display = "none";
            if (tagContainer || tagtopContainer) {
              fetch(`/products/${productHandle}?variant=${current_value}`)
                .then(res => res.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newTagContent = doc.querySelector('.card_product-content .card_product_tag');
                  const newtopTagContent = doc.querySelector('.card_product-content .price_top_tag-metadata');
                  if (newTagContent || tagtopContainer) {
                    tagContainer.innerHTML = newTagContent.innerHTML;
                    tagtopContainer.innerHTML = newtopTagContent.innerHTML;
                  }
                });
            }
          });
        });
        document.addEventListener("click", function (event) {
          if (!dropdown.contains(event.target)) {
            options.style.display = "none";
          }
        });
      });

      // collection description click for mobile
      document.querySelectorAll(".block__collection_page_tab_wrapper").forEach(function (wrapper) {
        const tooltips = wrapper.querySelectorAll(".tooltip");
      
        wrapper.addEventListener("click", function (event) {
          const clicked = event.target.closest(".tab-item");
          if (clicked) {
            const index = clicked.getAttribute("data-index");
            const tooltipToToggle = wrapper.querySelector(`.tooltip[data-index='${index}']`);
      
            if (tooltipToToggle) {
              const isVisible = tooltipToToggle.style.display === "block";
              wrapper.querySelectorAll(".tooltip").forEach(function (tooltip) {
                tooltip.style.display = "none";
              });
              tooltipToToggle.style.display = isVisible ? "none" : "block";
            }
            event.stopPropagation();
          }
        });
      
        // Stop tooltip clicks from bubbling and closing
        wrapper.querySelectorAll(".tooltip").forEach(function (tooltip) {
          tooltip.addEventListener("click", function (event) {
            event.stopPropagation();
          });
        });
      
        // Hide all tooltips on document click
        document.addEventListener("click", function () {
          wrapper.querySelectorAll(".tooltip").forEach(function (tooltip) {
            tooltip.style.display = "none";
          });
        });
      });
  
      // collection page sub category icon js
      document
        .querySelectorAll(".block__sub_colection_info_icon_wrapper")
        .forEach(function (subicon) {
          let iconCol = subicon.querySelector(
            ".block__sub_collection_info_icon_col"
          );
          let textCol = subicon.querySelector(
            ".block__sub_collection_info_text_col"
          );
          iconCol.addEventListener("click", function () {
            textCol.classList.add("active");
            setTimeout(() => {
              textCol.classList.remove("active");
            }, 3000);
          });
        });

      // ✅ Re-initialize Swiper after filters render
      const subCollectionSlider = document.querySelectorAll(
        ".block__sub_collection_flex_col.swiper"
      );
      subCollectionSlider &&
        subCollectionSlider.forEach((sub_collection) => {
          new Swiper(sub_collection, {
            slidesPerView: 5,
            spaceBetween: 0,
            loop: false,
            navigation: {
              nextEl: ".block__sub_collection_next_icon",
              prevEl: ".block__sub_collection_prev_icon",
            },
            breakpoints: {
              320: {
                slidesPerView: 2.5,
                spaceBetween: 6,
              },
              569: {
                slidesPerView: 3,
                spaceBetween: 12,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 13,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 13,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 13,
              },
              1300: {
                slidesPerView: 5,
                spaceBetween: 13,
              },
            },
          });
        });
    }, 500);

    window.scrollTo(0, 0);
  }

  static initQuantitySelectors(html) {
    document.querySelectorAll(".quantity-selector").forEach(function (selector) {
      let decreaseButton = selector.querySelector(".quantity-decrease");
      let increaseButton = selector.querySelector(".quantity-increase");
      let input = selector.querySelector(".quantity-input");

      decreaseButton.addEventListener("click", function () {
        if (parseInt(input.value) > 1) {
          input.value = parseInt(input.value) - 1;
        }
      });

      increaseButton.addEventListener("click", function () {
        input.value = parseInt(input.value) + 1;
      });
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }

  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


document.addEventListener('DOMContentLoaded', function () {
  // in stock filter toggle desktop
  document.querySelectorAll('.facets__summary-toggle-inner').forEach(toggleInner => {
    const mainInput = toggleInner.querySelector('input[type="checkbox"]');
    if (!mainInput) return;    
    document.querySelectorAll('.facets__disclosure-vertical').forEach(vertical => {
      const matchingInput = vertical.querySelector('.facets__item input[type="checkbox"][data-value="' + mainInput.value + '"]');
      if (matchingInput) {
        if (matchingInput.checked) mainInput.checked = true;
        if (matchingInput.disabled) mainInput.disabled = true;
      }
    });
    
    toggleInner.addEventListener('click', () => {
      const valueToMatch = mainInput.value;
      console.log(valueToMatch,'valueToMatchvalueToMatch');
      document.querySelectorAll('.facets__disclosure-vertical').forEach(vertical => {
        const matchingInput = vertical.querySelector('.facets__item input[type="checkbox"][data-value="' + valueToMatch + '"]');
        console.log(matchingInput,'matchingInput');
        if (matchingInput && matchingInput !== mainInput) {
          if (matchingInput.checked !== mainInput.checked) {
            matchingInput.click();
          }
        }
      });
    });
  });

  // in stock filter toggle mobile
  document.querySelectorAll('.facets__summary-toggle-inner-mobile').forEach(toggleInner => {
    const mainInput = toggleInner.querySelector('input[type="checkbox"]');
    if (!mainInput) return;
    
    document.querySelectorAll('.mobile-facets__item').forEach(item => {
      const matchingInput = item.querySelector('.mobile-facets__label input[type="checkbox"][data-value="' + mainInput.value + '"]');
      if (matchingInput) {
        if (matchingInput.checked) mainInput.checked = true;
        if (matchingInput.disabled) mainInput.disabled = true;
      }
    });    
    toggleInner.addEventListener('click', () => {
      const valueToMatch = mainInput.value;
      document.querySelectorAll('.mobile-facets__item').forEach(item => {
        const matchingInput = item.querySelector('.mobile-facets__label input[type="checkbox"][data-value="' + valueToMatch + '"]');
        if (matchingInput && matchingInput !== mainInput) {
          if (matchingInput.checked !== mainInput.checked) {
            matchingInput.click();
          }
        }
      });
    });
  });

});

//collection mobile sort by
document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.querySelector('.custom-mobile-sort-toggle');
  const drawer = document.getElementById('custom-mobile-sort-drawer');
  const closeBtn = document.querySelector('.block__mobile-facet-filter-close-icon');
  const drawerContent = document.querySelector('.block__sort_by_filter_drawer_col');

  if (toggleBtn && drawer) {
    toggleBtn.addEventListener('click', function () {
      drawer.classList.toggle('open');
      const isOpen = drawer.classList.contains('open');
      toggleBtn.setAttribute('aria-expanded', isOpen);
      document.querySelector('body').classList.add('overflow-hidden-mobile');
    });
  }

  // Close on close icon click
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', function () {
      drawer.classList.remove('open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('overflow-hidden-mobile');
    });
  }

  // Close when clicking outside the drawer content
  if (drawer && drawerContent) {
    drawer.addEventListener('click', function (e) {
      if (!drawerContent.contains(e.target)) {
        drawer.classList.remove('open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        document.querySelector('body').classList.remove('overflow-hidden-mobile');
      }
    });
  }

  //sort by filter
  const sortItems = document.querySelectorAll('.custom-sort-item');
  const sortSelect = document.getElementById('SortBy');
  const form = document.getElementById('FacetSortForm');
  if (!sortItems.length || !sortSelect || !form) {
    return;
  }
  sortItems.forEach(item => {
    item.addEventListener('click', function () {
      const selectedValue = item.getAttribute('data-value');
      sortSelect.value = selectedValue;
      form.submit();
    });
  });

  //filter close click mobile
  document.querySelector('.custom-mobile-facets__close').addEventListener('click', function () {
    document.querySelectorAll('.mobile-facets__disclosure.disclosure-has-popup').forEach(function (el) {
      el.removeAttribute('open');
      document.querySelector('body').classList.remove('overflow-hidden-mobile');
    });
  });

});
// Sort Filter MObile Body Overflow hidden  js

function handleMobileFacetsToggle() {
  const facet = document.querySelector('.mobile-facets__disclosure');

  if (!facet) return;

  const observer = new MutationObserver(() => {
    if (window.innerWidth < 991) {
      if (facet.hasAttribute('open')) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  });

  observer.observe(facet, { attributes: true, attributeFilter: ['open'] });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 991) {
      document.body.classList.remove('overflow-hidden');
    }
  });
}

document.addEventListener('DOMContentLoaded', handleMobileFacetsToggle);


// Sort Filter open Popup Body Add CLass
  function toggleBodyOverflow() {
    const drawer = document.querySelector('.block__sort_by_filter_drawer_wrapper');
    if (!drawer) return;

    const isMobile = window.innerWidth < 991;
    const isOpen = drawer.classList.contains('open');

    if (isMobile && isOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }

  // Trigger on load and resize
  window.addEventListener('load', toggleBodyOverflow);
  window.addEventListener('resize', toggleBodyOverflow);

  // Also trigger on any class change (e.g., toggle of 'open')
  const drawer = document.querySelector('.block__sort_by_filter_drawer_wrapper');
  if (drawer) {
    const observer = new MutationObserver(toggleBodyOverflow);
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

